import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IAddDocumentCategoryPayload, IEditDocumentCategoryPayload } from './document-category.interface';
import { catchError, map, throwError } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class DocumentCategoryService {
    private token!: string;
    private httpOptions: any;

    private basePath = environment.interop.basePath;

    private listDocumentCategoryUrl =
        this.basePath +
        environment.interop.dgaspc.nomenclatoare.cerereDocumentCategory.list;
    private listDTDocumentCategoryUrl =
        this.basePath +
        environment.interop.dgaspc.nomenclatoare.cerereDocumentCategory.listDT;
    private findDocumentCategoryUrl =
        this.basePath +
        environment.interop.dgaspc.nomenclatoare.cerereDocumentCategory.find;

    private storeDocumentCategoryURL =
        this.basePath +
        environment.interop.dgaspc.nomenclatoare.cerereDocumentCategory.store;
    private putDocumentCategoryURL =
        this.basePath +
        environment.interop.dgaspc.nomenclatoare.cerereDocumentCategory.update;

    private deleteDocumentCategoryURL =
        this.basePath +
        environment.interop.dgaspc.nomenclatoare.cerereDocumentCategory.delete;

    private clearCacheUrl =
        this.basePath +
        environment.interop.dgaspc.nomenclatoare.cerereDocumentCategory.clearCache;

    constructor(private http: HttpClient) { }

    listDocumentCategory() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.listDocumentCategoryUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get document categories:', error);
                    return throwError(error);
                })
            );
    }

    listDTDocumentCategory() {
        return this.http.post(this.listDTDocumentCategoryUrl, this.httpOptions);
    }

    findDocumentCategory() {
        return this.http.get(this.findDocumentCategoryUrl, this.httpOptions);
    }

    addDocumentCategory(category: IAddDocumentCategoryPayload) {
        return this.http.post(this.storeDocumentCategoryURL, category, this.httpOptions);
    }

    updateDocumentCategory(category: IEditDocumentCategoryPayload) {
        return this.http.put(this.putDocumentCategoryURL, category, this.httpOptions);
    }

    deleteDocumentCategory(categoryId: number) {
        return this.http.delete(this.deleteDocumentCategoryURL + categoryId);
    }

    clearCache() {
        return this.http.get(this.clearCacheUrl, this.httpOptions);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Category': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
